export default __webpack_public_path__ + "static/media/demo2.02249e9b.jpg";